/** Hero: copy deck §1. Conventional centered SaaS hero: bold DM Sans
 * headline, supporting copy, emerald primary CTA + secondary, and a clean
 * supporting product card below (PhishFence restraint: no faux schematic). */
import { StartFreeButton, AnchorButton } from './Cta.js';
import { DeliverabilityCard } from './DeliverabilitySchematic.js';

export function Hero() {
  return (
    <section id="top" className="px-4 pt-16 pb-12 sm:px-6 sm:pt-24 sm:pb-16">
      <div className="mx-auto max-w-3xl text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-brand-700 ring-1 ring-inset ring-brand-600/20">
          Deliverability-first cold email
        </span>
        <h1 className="mt-6 font-display text-4xl font-bold leading-tight tracking-tight text-slate-900 sm:text-5xl">
          Land in the inbox. Without torching your domain.
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-slate-600">
          RevBase sends from your real Google inbox with caps, ramp, warmup, and
          auto-pause built in, so your campaigns reach prospects and your domain
          reputation survives them. The other tools help you send more. We help
          you keep sending.
        </p>
        <div className="mt-9 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <StartFreeButton className="w-full sm:w-auto" />
          <AnchorButton href="#deliverability" className="w-full sm:w-auto">
            See how deliverability works
          </AnchorButton>
        </div>
        <p className="mt-6 text-sm text-slate-500">
          No credit card · Connect your Google inbox in two minutes · Cancel
          anytime
        </p>
      </div>

      <div className="mx-auto mt-14 max-w-3xl">
        <DeliverabilityCard />
      </div>
    </section>
  );
}
